import React, { useState, useRef, useEffect } from "react";
import SimpleReactValidator from "simple-react-validator";
import {
  Card,
  Typography,
  Input,
  Button,
} from "antd";
import {
  QrcodeOutlined,
  MailOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import {
  SpError,
} from '../../widgetDesign';

const { Title, Text } = Typography;

type Props = {
  createZellPayment: Function;
  zellPaymentSession: String,
  confirmZellPayment: Function,
};

const ZelleCheckout = (props: Props) => {
  const { createZellPayment, zellPaymentSession, confirmZellPayment } = props;

  const [, forceUpdate] = useState();
  const [zelleCode, setZelleCode] = useState("");
  const [spCode, setSpCode] = useState(zellPaymentSession.slice(-6));

  useEffect(() => {
    if (zellPaymentSession) {
      setSpCode(zellPaymentSession.slice(-6));
    }
  }, [zellPaymentSession])


  const simpleValidator = useRef(new SimpleReactValidator({}));

  // const spCode = "6AED9C";


  useEffect(() => {
    createZellPayment();
  }, [])

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!simpleValidator.current.allValid()) {
      simpleValidator.current.showMessages();
      forceUpdate(1);
      return;
    }
    confirmZellPayment(zelleCode);
  };

  return (
    <>
      {
        zellPaymentSession ? (
          <>
            <div style={styles.container}>
              <div style={styles.topSection}>
                <Card style={styles.qrCard} bordered={false}>
                  <div style={styles.qrHeader}>
                    <QrcodeOutlined />
                    <Text strong style={{ color: "#1677ff" }}>
                      SCAN TO PAY
                    </Text>
                  </div>

                  <div style={styles.qrBox}>
                    <img
                      src="https://swirepay-icon-prod.s3.ap-south-1.amazonaws.com/icon_url/zellQR.png"
                      alt="QR"
                      width="160"
                    />
                  </div>

                  <div style={styles.status}>
                    <span style={styles.greenDot}></span>
                    <Text type="secondary">Ready to scan</Text>
                  </div>
                </Card>
                <Card style={styles.infoCard}>
                  <div style={styles.infoHeader}>
                    <InfoCircleOutlined />
                    <Text strong>Important: Use This Code</Text>
                  </div>

                  <Text>
                    Enter this <b>SP Code</b> in the <b>Memo/Notes</b> field to process
                    your Zelle payment.
                  </Text>

                  <div style={styles.codeBox}>
                    <Text type="secondary">SP CODE</Text>
                    <Title level={3} style={{ margin: 0 }}>
                      {spCode.toLocaleUpperCase()}
                    </Title>
                  </div>

                  <Text type="secondary" style={{ fontSize: 12, color: '#000' }}>
                    • This code is case sensitive, Without this code, we won't be able to confirm your order
                  </Text>
                </Card>
              </div>
              <Title level={5} style={{ marginTop: 30 }}>
                Once you complete the Zelle payment, enter your Zelle ID and click submit
              </Title>

              <Card style={styles.formCard}>
                <Text strong>
                  <MailOutlined /> Enter Your Zelle Account Name{" "}
                  <span style={{ color: "red" }}>*</span>
                </Text>

                <Input
                  placeholder="Enter name zelle account name"
                  value={zelleCode}
                  onChange={(e) => setZelleCode(e.target.value)}
                  style={{ marginTop: 10, height: 45 }}
                />
                <SpError>
                  {simpleValidator.current.message('Zelle account name', zelleCode, 'required')}
                </SpError>

                <Text type="secondary" style={{ fontSize: 12 }}>
                  Enter the zelle account name you used to complete the payment
                </Text>
              </Card>

              <Button
                type="primary"
                size="large"
                style={styles.button}
                onClick={handleSubmit}
              >
                SUBMIT PAYMENT
              </Button>
            </div>
          </>
        ) : (
          <>
            <div style={styles.container}>
              <Title level={5} style={{ marginTop: 30 }}>
                Payment Method not support, Please try with another payment method.
              </Title>
            </div>
          </>
        )
      }
    </>

  );
};

export default ZelleCheckout;

const styles = {
  container: {
    padding: 40,
    background: "#f5f7fa",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },

  topSection: {
    display: "flex",
    gap: 40,
    flexWrap: "wrap",
    justifyContent: "center",
  },

  qrCard: {
    width: 260,
    borderRadius: 16,
    textAlign: "center",
    boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
  },

  qrHeader: {
    display: "flex",
    justifyContent: "center",
    gap: 8,
    marginBottom: 12,
  },

  qrBox: {
    padding: 15,
    background: "#fafafa",
    borderRadius: 12,
  },

  status: {
    marginTop: 10,
    display: "flex",
    justifyContent: "center",
    gap: 6,
  },

  greenDot: {
    width: 8,
    height: 8,
    background: "green",
    borderRadius: "50%",
  },

  infoCard: {
    width: 320,
    borderRadius: 16,
    border: "1px solid #d6e4ff",
    boxShadow: "0 8px 20px rgba(0,0,0,0.05)",
  },

  infoHeader: {
    display: "flex",
    gap: 8,
    alignItems: "center",
    marginBottom: 10,
    color: "#1677ff",
  },

  codeBox: {
    marginTop: 15,
    marginBottom: 15,
    padding: 15,
    borderRadius: 10,
    border: "2px solid #1677ff",
    textAlign: "center",
    background: "#f0f5ff",
  },

  formCard: {
    width: "100%",
    maxWidth: 500,
    marginTop: 20,
    borderRadius: 12,
  },

  button: {
    marginTop: 30,
    width: 260,
    height: 50,
    borderRadius: 25,
    fontWeight: "bold",
  },
};